import * as React from 'react';
import { SliderBarContainer } from './SliderBar.style';
export var SliderBar = function (_a) {
    var from = _a.from, to = _a.to, indicators = _a.indicators;
    var indicatorRanges = React.useMemo(function () {
        return indicators.map(function (indicator) {
            var insideRanges = [];
            if (indicator.range[0] < to && indicator.range[1] > from) {
                insideRanges.push([
                    Math.max(indicator.range[0], from),
                    Math.min(indicator.range[1], to),
                ]);
            }
            return {
                raw: indicator,
                ranges: insideRanges,
            };
        });
    }, [from, indicators, to]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SliderBarContainer, { "data-main": true, "data-testid": "slider-bar", style: { left: "".concat(from, "%"), right: "".concat(100 - to, "%") } }),
        indicatorRanges.map(function (indicator, index) { return (React.createElement(React.Fragment, { key: index }, indicator.ranges.map(function (indicatorRange, rangeIndex) { return (React.createElement(SliderBarContainer, { key: rangeIndex, style: {
                left: "".concat(indicatorRange[0], "%"),
                right: "".concat(100 - indicatorRange[1], "%"),
                backgroundColor: indicator.raw.color,
            } })); }))); })));
};
//# sourceMappingURL=SliderBar.js.map